import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { ToggleFullscreenDirective } from "./directives/toggle-fullscreen.directive";
import { CustomDataByRequestTypeComponent } from '../ncs/custumcomponents/ddlbyrequesttype/customdatabyrequesttype.componenet';
import { AutoSearchComponent } from '../ncs/custumcomponents/autosearch/autosearch.component';
import { DataGrid } from '../ncs/custumcomponents/datagrid/datagrid.component';
import { Format } from '../ncs/custumcomponents/datagrid/format';
import { OrderBy } from '../ncs/custumcomponents/datagrid/orderby';
import { SearchComponent } from '../ncs/custumcomponents/search/search.component';
import { DetailGrid } from '../ncs/custumcomponents/detailgrid/detailgrid.component';
import { CodeTypeValueComponent } from '../ncs/custumcomponents/codetypes/codetypevalue.component';
import { CanUserAccess } from '../ncs/models/accesscheck';

const SHARED_COMPONENTS_AND_DIRECTIVES = [
    ToggleFullscreenDirective,
    CustomDataByRequestTypeComponent,
    AutoSearchComponent,
    DataGrid,
    Format,
    OrderBy,
    SearchComponent,
    DetailGrid,
    CodeTypeValueComponent,
    CanUserAccess
];

@NgModule({
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        TranslateModule,
        ...SHARED_COMPONENTS_AND_DIRECTIVES
    ],
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        TranslateModule
    ],
    declarations: [
        ...SHARED_COMPONENTS_AND_DIRECTIVES
    ]
})
export class SharedModule { }
